import { render, staticRenderFns } from "./quinta-do-vale-meao.vue?vue&type=template&id=08433045&scoped=true"
import script from "./quinta-do-vale-meao.vue?vue&type=script&lang=js"
export * from "./quinta-do-vale-meao.vue?vue&type=script&lang=js"
import style0 from "./quinta-do-vale-meao.vue?vue&type=style&index=0&id=08433045&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08433045",
  null
  
)

export default component.exports